import {Request} from "../core/request";
import {AuthHeader} from "../core/token";

export interface Share {
    ID: number; // 分享的唯一标识
    CreatedAt: string; // 创建时间
    UpdatedAt: string; // 更新时间
    DeletedAt: string | null; // 删除时间（如果未删除则为 null）
    FileID: number; // 关联的文件 ID
    FileUUid: string; // 关联的文件 UUID

    NotExpiry: boolean; // 是否永不过期
    ShareExpiry: string | null; // 分享过期时间

    ShareStartTime: string | null;
    ShareEndTime: string | null;
    Remark: string; // 备注
    type: "user" | "group" | "password"; // 分享类型
    UserId: number; // 用户 ID（如果是用户分享）
    UserName: string; // 用户名（如果是用户分享）
    GroupId: number; // 组 ID（如果是组分享）
    GroupName: string; // 组名（如果是组分享）
    SharePasswordUUid: string; // 分享密码的 UUID（如果是密码分享）
    SharePassword: string; // 分享密码（如果是密码分享）

    ShareAuthUserID: number // 共享权限的老师
    FileByUserID : number // 文件归属的老师
    ShareAuthUserName : string
}

export interface createShareRequest {
    type: string;
    remark?: string;
    user_id?: number;
    group_id?: number;
    share_password?: string;
    expiry_time?: number;
    start_date?: string;
    end_date?: string;
    start_delay?: number; // 延迟生效时间，按秒（多少秒后开始生效）
}

export async function getFileShares(fileId: number): Promise<Share[]> {
    const resp = await Request.get(`/academics/files/share/${fileId}`, {headers: AuthHeader()});
    return resp.data
}

export async function createFileShares(fileId: number, request: createShareRequest) {
    return await Request.post(`/academics/files/share/${fileId}`, request, {headers: AuthHeader()});
}

export async function deleteFileShares(fileId: number, shareId: number) {
    return await Request.delete(`/academics/files/share/${fileId}/${shareId}`, {headers: AuthHeader()});
}

export async function updateFileShare(fileId: number, shareId: number, request: createShareRequest) {
    return await Request.put(`/academics/files/share/${fileId}/${shareId}`, request, {headers: AuthHeader()});
}

export interface FileShareInfo {
    file_id: number;
    shares: Share[];
}

export async function batchGetFileShares(fileIds: number[]): Promise<FileShareInfo[]> {
    const resp = await Request.post(`/academics/files/share/batch`, {file_ids: fileIds}, {headers: AuthHeader()});
    return resp.data;
}
